import React from 'react'

function Thead({ children }) {
    return (
        <thead
            className='text-gray-400 text-sm tracking-wide text-left border-b border-b-gray-100 font-[400]'
        >
            {children}
        </thead>
    )
}

export default Thead